define([
  'es6!sumo/util',
  'immutable',
  'underscore',
  'es6!launcher/actions/ListBuilderActions',
  'es6!launcher/util/listbuilder/constants',
], (Util, Immutable, _, Actions, Constants) => {
  const { FormTypes, FormGoals, DEFAULT_LB_TEST_FILTERS } = Constants;

  const initialState = Immutable.Map({
    // hasLoaded is set when we load settings. We need it so we don't do certain
    // things without having the correct settings. For instance, if the user is pro
    // but the settings load after the popup, the popup will fail validatino and the
    // default popup will be shown.
    hasLoaded: false,
    isPopupChanged: false,
    page: 1,
    limit: 10,
    sortKey: 'name',
    total: 0,
    name: '',
    status: [
      'active',
      'paused',
      'variants',
    ],
    formType: [
      FormTypes.SMART_BAR,
      FormTypes.POPUP,
      FormTypes.INLINE_POPUP,
      FormTypes.CLICK_TRIGGER_POPUP,
      FormTypes.WELCOME_MAT,
      FormTypes.SCROLL_BOX,
      FormTypes.GAME,
      FormGoals.SOCIAL_PROOF,
    ],
    isPro: false,
    isAdmin: false,
    duplicateSuccess: false,
    reqId: null,
    hash: null,
    notice: Immutable.Map(),
    tests: Immutable.Map(),
    isScrollBoxUnlocked: false,
    isSmartBarUnlocked: false,
    isWelcomeMatUnlocked: false,
    autoResponseDefaultSender: null,
    switchPreview: null,
    newProductId: null,
    inventoryId: null,
    pushSubdomainName: null,
    showGameOptions: false,
    gameOptionsError: null,
    testingGame: false,
    shouldPromptShopifyReview: false,
    formOptions: Immutable.Map(),
    pageTest: 1,
    limitTest: 5,
    totalTest: 0,
    statusTest: Immutable.fromJS(DEFAULT_LB_TEST_FILTERS),
  });

  const actionHandlers = {};

  const cleanSettings = (state, settings) => (
    Object.keys(settings).reduce((memo, key) => {
      if (!settings[key]) return memo;

      return {
        ...memo,
        [key]: settings[key],
      };
    }, {})
  );

  actionHandlers[Actions.RECEIVE_SETTINGS] = (state, action) => {
    const settings = action.settings || {};
    const nextSettings = {
      ...cleanSettings(state, settings),
      hasLoaded: true,
    };

    return state.merge(nextSettings);
  };

  actionHandlers[Actions.UPDATE_SETTING] = (state, action) => {
    const settingName = action.setting;
    const settingValue = action.value;

    if (Array.isArray(settingName)) {
      return state.setIn(settingName, settingValue);
    }

    return state.setIn([settingName], settingValue);
  };

  actionHandlers[Actions.RECEIVE_SWITCH_PREVIEW] = (state, action) => {
    const switchPreview = action.switchPreview;
    return state.set('switchPreview', switchPreview ? Immutable.fromJS(switchPreview) : null)
  };

  return Util.createReducer(initialState, actionHandlers);
});
